import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Box, Typography, Link } from '@mui/material';
import { useI18n } from '@/hooks/useI18n';

const NotFound = () => {
  const location = useLocation();
  const { t } = useI18n();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'grey.100'
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h1" component="h1" sx={{ fontSize: '4rem', fontWeight: 'bold', mb: 2 }}>
          404
        </Typography>
        <Typography variant="h5" color="text.secondary" sx={{ mb: 2 }}>
          {t('pages.notFound.title')}
        </Typography>
        <Link href="/" sx={{ color: 'primary.main', textDecoration: 'underline' }}>
          {t('pages.notFound.goHome')}
        </Link>
      </Box>
    </Box>
  );
};

export default NotFound;
